import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { DashboardProvider } from "../contexts/DashboardContext";
import { DialogProvider } from "../contexts/DialogContext";
import { TenantProvider } from "../contexts/TenantContext";
import { UserProvider } from "../contexts/UserContext";
import { AgreementTrackerProvider } from "../contexts/AgreementTrackerContext";
import { BalanceStatementProvider } from "../contexts/BalanceStatementContext";
import { DailyUserProvider } from "../contexts/DailyUserContext";
import { RadUserPlanProvider } from "../contexts/RadUserPlanContext";
import { RateProvider } from "../contexts/RateContext";
import { PlanProvider } from "../contexts/PlanContext";
import { ComplaintProvider } from "../contexts/ComplaintContext";
import { AuthenticationLogProvider } from "../contexts/AuthenticationLogContext";
import { PaidInvoiceProvider } from "../contexts/PaidInvoiceContext";
import { UnpaidInvoiceProvider } from "../contexts/UnpaidInvoiceContext";

export const DashboardComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <DashboardProvider key={0} />,
        <TenantProvider key={1} />,
        <UserProvider key={2} />,
        <AgreementTrackerProvider key={3} />,
        <BalanceStatementProvider key={4} />,
        <DailyUserProvider key={5} />,
        <RadUserPlanProvider key={6} />,
        <RateProvider key={7} />,
        <PlanProvider key={8} />,
        <ComplaintProvider key={9} />,
        <AuthenticationLogProvider key={10} />,
        <PaidInvoiceProvider key={12} />,
        <UnpaidInvoiceProvider key={13} />,
        <DialogProvider key={11} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
